import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BillingInvoiceRoutingModule } from './billing-invoice-routing.module';

import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";

import { PERFECT_SCROLLBAR_CONFIG } from "ngx-perfect-scrollbar";

import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { FeahterIconModule } from 'src/app/core/feather-icon/feather-icon.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { MerchantBillingComponent } from './merchant-billing/merchant-billing.component';
import { MerchantBillingSettingsComponent } from './merchant-billing-components/merchant-billing-settings/merchant-billing-settings.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgbAlertModule, NgbDropdownModule, NgbNavModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'src/app/shared/shared.module';
import { ArchwizardModule } from 'angular-archwizard';
import { FieldsetModule } from 'primeng/fieldset';
import { TooltipModule } from 'primeng/tooltip';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { ReactiveFormsModule } from '@angular/forms';
import { AccordionModule } from 'primeng/accordion';
import { InputNumberModule } from 'primeng/inputnumber';
import { CheckboxModule } from 'primeng/checkbox';
import { ToastModule } from 'primeng/toast';
import { MerchantContractComponent } from './merchant-billing-components/merchant-contract/merchant-contract.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { MerchantContractBillingComponent } from './merchant-contract-billing/merchant-contract-billing.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { UiSwitchModule } from 'ngx-ui-switch';
import { InvoiceDetailComponent } from './merchant-billing-components/invoice-detail/invoice-detail.component';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  declarations: [
    MerchantBillingComponent,
    MerchantBillingSettingsComponent,
    MerchantContractComponent,
    MerchantContractBillingComponent,
    InvoiceDetailComponent
  ],
  imports: [
    FeahterIconModule,
    CommonModule,
    SharedModule,
    BillingInvoiceRoutingModule,
    PerfectScrollbarModule,
    NgSelectModule,
    TranslateModule,
    NgbDropdownModule,
    ArchwizardModule,
    FieldsetModule,
    TooltipModule,
    MessageModule,
    MessagesModule,
    ReactiveFormsModule,
    AccordionModule,
    NgbAlertModule,
    InputNumberModule,
    CheckboxModule,
    ToastModule,
    NgxIntlTelInputModule,
    InputSwitchModule,
    UiSwitchModule,
    NgbNavModule,
    NgbPaginationModule
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
  ],
})
export class BillingInvoiceModule { }
